var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{staticClass:"left-aligned annotation-details",attrs:{"type":"is-dark","animated":false,"position":"is-bottom"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"label-details"},[(_vm.description)?_c('div',{staticClass:"label-description"},[_c('span',[_vm._v(_vm._s(_vm.description))])]):_vm._e(),(_vm.accuracy)?_c('div',{staticClass:"accuracy"},[_c('span',[_vm._v(_vm._s(_vm.$t("accuracy")))]),_c('span',{class:[
            'value',
            _vm.accuracy <= 0.2 ? 'red' : _vm.accuracy <= 0.5 ? 'yellow' : '',
          ]},[_vm._v(_vm._s(Math.floor(_vm.accuracy * 100) / 100))])]):_vm._e(),_c('div',{staticClass:"revision"},[_c('div',{staticClass:"detail-icons"},[(_vm.created || _vm.edited)?_c('div',[(_vm.accepted)?_c('div',{class:[
                'annotation-details-icon',
                _vm.animate ? 'animated-ripple' : '',
                'user-icon',
              ]},[_c('AcceptedUser')],1):_c('div',{class:[
                'annotation-details-icon',
                _vm.animate ? 'animated-ripple' : '',
                'user-icon',
              ]},[_c('UserIcon')],1)]):(_vm.notFound)?_c('div',{class:[
              'annotation-details-icon',
              _vm.animate ? 'animated-ripple' : '',
              'question-icon',
            ]},[_c('QuestionMark')],1):_c('div',[(_vm.accepted)?_c('div',{class:[
                'annotation-details-icon',
                _vm.animate ? 'animated-ripple' : '',
              ]},[_c('AcceptedCheckMark')],1):_c('div',{class:[
                'annotation-details-icon',
                _vm.animate ? 'animated-ripple' : '',
              ]},[_c('CheckMark')],1)]),_vm._v(" "+_vm._s(_vm.getText())+" ")])])])]},proxy:true}])},[_c('div',{staticClass:"label-icon"},[(_vm.created || _vm.edited)?_c('div',[(_vm.accepted)?_c('div',{class:[
          'annotation-details-icon',
          _vm.animate ? 'animated-ripple' : '',
          'user-icon',
        ]},[_c('AcceptedUser')],1):_c('div',{class:[
          'annotation-details-icon',
          _vm.animate ? 'animated-ripple' : '',
          'user-icon',
        ]},[_c('UserIcon')],1)]):(_vm.notFound)?_c('div',{class:[
        'annotation-details-icon',
        _vm.animate ? 'animated-ripple' : '',
        'question-icon',
      ]},[_c('QuestionMark')],1):_c('div',[(_vm.accepted)?_c('div',{class:['annotation-details-icon', _vm.animate ? 'animated-ripple' : '']},[_c('AcceptedCheckMark')],1):_c('div',{class:['annotation-details-icon', _vm.animate ? 'animated-ripple' : '']},[_c('CheckMark',{staticClass:"pending"})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }